module.exports = __webpack_public_path__ + "static/media/inhaler.027207f9.svg";